import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { ActionPayload, DataLakeFileDownloadRequestInput } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
const MUTATION_DOWNLOAD_FILE = gql`
    mutation executeDataLakeFileDownload ($input: DataLakeFileDownloadRequestInput!){
        executeDataLakeFileDownload(input: $input) {
            message
            errors {
                code
                message
            }
            result
            data
        }
    }
`;

export const MutationDownloadDataLakeFile = async (
    client: ApolloClient<NormalizedCacheObject>,
    fileInput: DataLakeFileDownloadRequestInput
    ): Promise<ActionPayload | undefined> => {
        const { 
            blobDocumentFormat, 
            fileNameWithFullPath, 
        } = fileInput as DataLakeFileDownloadRequestInput;
        const {data, errors } = await client.mutate<{executeDataLakeFileDownload: ActionPayload}>({
            variables: {
                input: {
                    blobDocumentFormat, 
                    fileNameWithFullPath, 
                }
            },
            mutation: MUTATION_DOWNLOAD_FILE
        });
        if (errors && errors.length > 0) {
            errors.forEach(error => {
                // Log error details in the console
                console.error(error);
            });
            // Friendly error to active user
            throw new Error('An error has occurred trying to execute Data Lake file download.');
        }
        if (data && data.executeDataLakeFileDownload) {
            return data.executeDataLakeFileDownload;
        }
    
        return undefined;
    };